import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = '/favicon.ico';
        document.head.appendChild(link);
    }, []);

    return (
        <header className="bg-white shadow-xs">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center">
                            <div className="bg-primary-600 h-16 px-4 flex items-center justify-center">
                                <img
                                    src="/openleis_logo.png"
                                    alt="OpenLEIs"
                                    className="h-14 w-auto block"
                                />
                            </div>
                        </Link>
                    </div>

                    {/* Right side */}
                    <div className="flex items-center space-x-1 sm:space-x-2">
                        <div className="text-xs sm:text-sm text-gray-500 hidden sm:block">
                            brought to you by
                        </div>
                        <div className="text-xs text-gray-500 block sm:hidden">by</div>
                        <img src="/oc.png" alt="OpenCorporates" className="h-4 sm:h-6" />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
